import { PageName } from '../../translations/translationType';
import {
    PAGE_BARN_URL,
    PAGE_BILER_URL,
    PAGE_BOLIGSALG_URL,
    PAGE_BOLIGVERDI_URL,
    PAGE_EGENKAPITAL_URL,
    PAGE_GJELD_URL,
    PAGE_INNTEKT_URL,
    PAGE_KONTAKTINFORMASJON_URL,
    PAGE_LAANEBELOP_URL,
    PAGE_LEIEINNTEKT_URL,
    PAGE_OPPSUMMERING_URL,
    PAGE_SAMTYKKE_URL,
    PAGE_VEDLEGG_URL,
} from './pageUrl';

const PageTitle = (page: string, pageName: PageName): string => {
    switch (page) {
        case PAGE_BOLIGVERDI_URL:
            return pageName.boligverdi;
        case PAGE_BOLIGSALG_URL:
            return pageName.boligsalg;
        case PAGE_LAANEBELOP_URL:
            return pageName.laanebeloep;
        case PAGE_KONTAKTINFORMASJON_URL:
            return pageName.kontaktinformasjon;
        case PAGE_SAMTYKKE_URL:
            return pageName.samtykke;
        case PAGE_INNTEKT_URL:
            return pageName.inntekt;
        case PAGE_LEIEINNTEKT_URL:
            return pageName.leieinntekt;
        case PAGE_BILER_URL:
            return pageName.biler;
        case PAGE_BARN_URL:
            return pageName.barn;
        case PAGE_EGENKAPITAL_URL:
            return pageName.egenkapital;
        case PAGE_GJELD_URL:
            return pageName.gjeld;
        case PAGE_VEDLEGG_URL:
            return pageName.vedlegg;
        case PAGE_OPPSUMMERING_URL:
            return pageName.oppsummering;
        default:
            return '';
    }
};

export default PageTitle;
